import { Select, spacing, Strong } from 'main/ui'
import * as React from 'react'
import { IParams, IValidation } from './types'

interface IProps {
  params: IParams
  validation: IValidation
  onChange: (changes: Partial<IParams>) => void
}

export default function Fields(props: IProps) {
  const { params, validation, onChange } = props

  return (
    <div>
      <div css={{ marginBottom: spacing.majorScale(2) }}>
        <Strong>Please RSVP for adults and children</Strong>
      </div>
      <Select
        label="How many will be attending?"
        invalid={!!validation.quantity}
        onChange={quantity => {
          if (quantity) onChange({ quantity: parseInt(quantity, 10) })
        }}
        value={`${params.quantity}`}
        required
      >
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
      </Select>
    </div>
  )
}
